import { useContext } from 'react'
import { HistoryContext } from '../context/history-context'

export const useHistory = () => {
  const state = useContext(HistoryContext)!;

  return state;
}